import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { swiperOptions } from '@src/components/swiper/base-swiper/swiper-options';
import { observable } from 'mobx';

import { getOmniData, newData, NewsChannelId, NewsImgId, NewsTopDataId } from '@src/services/omni-api';

import { useEffect } from 'react';
import Toast from '@src/components/toast';
import $$tracker from '@src/tracker';
import { aLink } from '@src/utils/common-util';
import { createContentRouteUrl, isAbsoluteUrl } from '@src/utils/content-route-util';
class NewsStore {
  newsBannerBaseSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      pagination: {
        el: '#main-group-9',
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      ...swiperOptions.default
    }
  });

  page = 1;
  pageSize = 10;

  @observable newsImgList = [];

  /**
   * 最新
   * 新闻
   * 公告
   * 活动
   * @type {string}
   */
  @observable currentTab = '最新';

  /**
   * 点击跳转
   */
  @observable redirect;

  @observable newsList;

  @observable categoryId;

  @observable topData;

  /**
   * 切换tab
   * @param tab
   */
  onTabClick = tab => {
    $$tracker.clickJhkbNav(tab);
    this.currentTab = tab;
  };

  /**
   * 点击更多
   */
  onMoreClick = () => {
    $$tracker.clickJhkbNav('更多');
    aLink(createContentRouteUrl('/news-list', { categoryId: this.categoryId }));
  };

  /**
   * 点击进入文章详情
   * @param item
   */
  onNewsItemClick = (item, type = 'details') => {
    if (type === 'swiper') {
      $$tracker.clickJhkbLunbotu(item.title);
    } else {
      $$tracker.clickJhkbDetails(item.title);
    }

    const jumpLink = typeof item.jump_link === 'string' ? item.jump_link.trim() : '';
    if (jumpLink === 'stay') {
      return;
    }

    if (isAbsoluteUrl(jumpLink)) {
      // 轮播图等条目由 CMS 直接配置完整链接(已带正确的 contentId/categoryId), 直接使用
      aLink(jumpLink);
    } else if (jumpLink === 'link') {
      // window.open(item.art_link.url);
      let url = item.art_link?.url || item.silder_link?.url || '';
      if (url) {
        aLink(url);
      }
    } else {
      aLink(createContentRouteUrl('/news-detail', { categoryId: this.categoryId, contentId: item.contentId, page: 1 }));
    }
  };

  getNewsChennelList = async () => {
    try {
      // 轮播图
      const res = await getOmniData('channel_cat_e9f08e88', [
        {
          dataSourceId: 'ds_cat_a8ffb6a9' || '',
          page: 1,
          perPage: 10
        }
      ]);

      if (res.ds_cat_a8ffb6a9.result?.items?.[0]) {
        this.newChennelInfo = res.ds_cat_a8ffb6a9.result?.items?.[0] || {};
        // console.log(res, this.newChennelInfo);
      }
    } catch (error) {
      console.log(error);
    }
  };
  openNewTab = key => {
    if (!this.newChennelInfo[key]) {
      Toast.fail('链接不存在');
      return;
    }
    aLink(this.newChennelInfo[key]);
  };

  /**
   * 获取轮播图
   */
  getNewsImgList = () => {
    this.getNewsListAsync([
      {
        dataSourceId: NewsImgId || '',
        page: this.page,
        perPage: this.pageSize
      }
    ])
      .then(res => {
        // console.log(res, '----------------------');
        if (res[NewsImgId].result?.items) {
          this.newsImgList = res[NewsImgId].result?.items;
          // this.newsImgList = res[NewsImgId].result?.items.map(item => {
          //   return {
          //     url: item.rotating_chart[0]?.url || '',
          //     contentId: item.contentId || '',
          //     title: item.title || ''
          //   };
          // });
        }
      })
      .catch(err => {
        Toast.fail(err?.msg);
      });
  };

  getNewsList = () => {
    this.getNewsListAsync([
      {
        dataSourceId: this.categoryId || '',
        page: this.page,
        perPage: 4
      }
    ])
      .then(res => {
        this.newsList = res[this.categoryId].result.items;
      })
      .catch(err => {
        Toast.fail(err?.msg);
      });
  };

  getTopData = () => {
    this.getNewsListAsync([
      {
        dataSourceId: NewsTopDataId || '',
        page: this.page,
        perPage: 1
      }
    ])
      .then(res => {
        this.topData = res[NewsTopDataId].result.items[0];
      })
      .catch(err => {
        Toast.fail(err?.msg);
      });
  };

  getNewsListAsync = dataSources => {
    return getOmniData(NewsChannelId, dataSources);
  };
  constructor(options = {}) {
    Object.assign(this, options);
  }

  use() {
    useEffect(
      () => {
        if (this.currentTab) {
          this.categoryId = newData.find(item => item.title === this.currentTab)?.id;
          this.getNewsList();
        }
      },
      [this.currentTab]
    );
    useEffect(
      () => {
        if (this.newsImgList.length === 0) {
          return;
        }

        // $$tracker.clickJhkbLunbotu(this.newsImgList[this.newsBannerBaseSwiperStore.activeIndex]?.title);
      },
      [this.newsBannerBaseSwiperStore.activeIndex, this.newsImgList]
    );
    useMount(async () => {
      this.getNewsImgList();
      this.getTopData();
      this.getNewsChennelList();
    });
  }
}

export default NewsStore;
